import React from 'react';
import axios from 'axios';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadIcon from '@material-ui/icons/CloudUpload';
import NewIcon from '@material-ui/icons/CreateNewFolder';
import NewClientIcon from '@material-ui/icons/People';
import RenameIcon from '@material-ui/icons/Adjust';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import ViewIcon from '@material-ui/icons/TextRotateUp';
import ListenAllIcon1 from '@material-ui/icons/Subscriptions'
import ListenAllIcon2 from '@material-ui/icons/SubscriptionsOutlined'

import DeliverReportIcon from '@material-ui/icons/Send';


import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import Tooltip from '@material-ui/core/Tooltip';

import SimpleDialog from './SimpleDialog';
import FormDialog from './FormDialog';
import ViewDialog from './ViewDialog';
import InfoDialog from './InfoDialog';
import DeliverReportDialog from './DeliverReportDialog';
import AssignRoleDialog from './AasignRoleDialog';
import Preview from './Preview';
import MetaData from './MetaData';
import History from './History';


import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import TextFiled from '@material-ui/core/TextField';

import {
    Toolbar, Checkbox, Divider, List, ListItem, ListItemText, ListItemIcon,
    Table, TableBody, TableHead, TableRow, TableCell,
    Button
} from '@material-ui/core';

import {
    Add, Remove, PersonAdd, PersonAddDisabled
} from '@material-ui/icons';

import RoleAndUserNewUserDialog from './RoleAndUserNewUserDialog';

export class RoleAndUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = { roles: [], users: [], role: null, user: null, filter:null };

        this.onRoleChange = this.onRoleChange.bind(this);
        this.addRole = this.addRole.bind(this);
        this.deleteRole = this.deleteRole.bind(this);
        this.addUser = this.addUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);

        this.showAxiosError = this.showAxiosError.bind(this);
        this.loadIsAdminAndAllRoles = this.loadIsAdminAndAllRoles.bind(this);
    }
    loadIsAdminAndAllRoles() {
        axios.get('/api/docx/isAdmin')
            .then(response => {
                const isAdmin = response.data;
                if (isAdmin) {
                    axios.get("/api/docx/allRoles")
                        .then(response => {
                            this.setState({ isAdmin, roles: response.data });
                        }).catch(error => alert(error.message));
                }
            }).catch(this.showAxiosError);
    }
    componentDidMount() {
        this.loadIsAdminAndAllRoles();
    }
    showAxiosError(error) {
        if (error.response && error.response.data) {
            this.infoDialog.show(error.response.data, "ERROR: " + error.response.status, true);
        } else {
            this.infoDialog.show(JSON.stringify(error), "ERROR", true);
        }
    }
    onRoleChange(role) {
        axios.post('/api/docx/getUsersByRole', { roleName: role })
            .then(response => {
                this.setState({ role, users: response.data });
            }).catch(error => {
                alert(error.message);
            });
    }
    addRole() {
        const { roles } = this.state;
        this.formDialog.show("New Client", "", null, name => {
            axios.post("api/docx/createRole", { roleName:name } )
                .then(response => {
                    this.setState({ roles: response.data });
                })
                .catch(this.showAxiosError);
        });
    }
    deleteRole() {
        const {roles, role } = this.state;
        this.simpleDialog.show("Are you sure to delete client " + role + "?", r => {
            if (r) {
                axios.post('api/docx/deleteRole', { roleName: role })
                    .then(response => {

                        this.setState({ roles: response.data, role: null });
                    })
                    .catch(this.showAxiosError);
            }
        });
    }
    addUser() {
        const { users } = this.state;
        this.newUserDialog.show(p => {
            p.roleName = this.state.role;
            axios.post('api/docx/createUser', p)
                .then(response => {
                    users.push(p);
                    this.setState({ users });
                })
                .catch(this.showAxiosError);
        });
    }
    deleteUser() {
        const { users, user } = this.state;
        this.simpleDialog.show("Are you sure to delete user " + user.userName + "?", r => {
            if (r) {
                axios.post('api/docx/deleteUser', user)
                    .then(response => {
                        const index = users.indexOf(user);
                        users.splice(index, 1);
                        this.setState({ users, user: null });
                    })
                    .catch(this.showAxiosError);
            }
        });
    }
    render() {

        if (!this.state.isAdmin) {
            return '';
        }

        var { roles, users, role, user,filter } = this.state;

        roles = roles.filter(p => !filter || (p && p.toUpperCase().startsWith(filter.toUpperCase().trim())));

        const isShowRoleOp = false;

        return (
            <div>
               
                <Toolbar style={{ backgroundColor: '#eee', boxShadow: '3px 3px #ccc', borderRadius: '3px' }}>
                        <Typography variant="h6" color="primary" style={{ marginRight: '30px' }}>
                            Client & User
                        </Typography>
                        <TextFiled label='Filter Clients'
                            onChange={e => this.setState({ filter: e.target.value }) } variant = 'outlined' />
                    {
                        isShowRoleOp?<Tooltip title={'Add Client'}><div>
                            <IconButton onClick={this.addRole}><Add /></IconButton>
                        </div></Tooltip>
                            :''
                    }
                        
                    {
                        isShowRoleOp ?
                                <Tooltip title={'Remove Client'}><div>
                                    <IconButton onClick={this.deleteRole}><Remove /></IconButton>
                                </div></Tooltip>
                                : ''
                        }
                        {
                            role ?
                                <Tooltip title={'New User'}><div>
                                    <IconButton onClick={this.addUser}><PersonAdd /></IconButton>
                                </div></Tooltip>
                                : ''
                        }
                        {
                            user ?
                                <Tooltip title={'Remove User'}><div>
                                    <IconButton onClick={this.deleteUser}><PersonAddDisabled /></IconButton>
                                </div></Tooltip>
                                : ''
                        }
                    </Toolbar>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1, overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                        <List>
                            {
                                roles.map(p =>
                                    <ListItem selected={p === role} key={p}
                                        onClick={() => this.onRoleChange(p)} dense button>
                                        <ListItemText>{p}</ListItemText>
                                    </ListItem>)
                            }
                        </List>
                    </div>
                    <div style={{ flex: 1, overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                        <Table hover>
                            <TableHead>
                                <TableRow>
                                    <TableCell>User Name</TableCell>
                                    <TableCell>Email</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (users || []).map(p =>
                                        <TableRow selected={p == user} hover onClick={() =>
                                            this.setState({ user: p })}>
                                            <TableCell>{p.userName}</TableCell>
                                            <TableCell>{p.email}</TableCell>
                                        </TableRow>
                                        )
                                }
                                
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <SimpleDialog ref={ref => this.simpleDialog = ref} />
                <FormDialog ref={ref => this.formDialog = ref} />
                <ViewDialog ref={ref => this.viewDialog = ref} />
                <InfoDialog ref={ref => this.infoDialog = ref} />
                <RoleAndUserNewUserDialog ref={ref => this.newUserDialog = ref}/>
            </div>
        );
    }
}